import H5 from '@base/H5/H5';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import { getAmPm, getTimeWithoutAmPm12HrFormat } from '@utils/dates';
import PropTypes from 'prop-types';
import { MicroText } from './PlannerElements';

const Wrapper = styled.div`
  display: grid;
  grid-template: 1fr / 80px 1fr;
  grid-column-gap: ${Spacings.SPACING_2B};
  position: relative;
  overflow: visible;
`;

const TimeWrapper = styled.div`
  text-align: center;
  padding-top: ${Spacings.SPACING_4B};
`;

const Meridian = styled(MicroText)`
  font-weight: ${Fonts.BOLD};
`;

const PlannerCardFrame = ({ activityAt, children }) => {
  return (
    <Wrapper>
      <TimeWrapper>
        <H5>{getTimeWithoutAmPm12HrFormat(activityAt)}</H5>
        <Meridian>{getAmPm(activityAt)}</Meridian>
      </TimeWrapper>
      {children}
    </Wrapper>
  );
};

PlannerCardFrame.propTypes = {
  activityAt: PropTypes.number.isRequired,
  children: PropTypes.node
};

PlannerCardFrame.defaultProps = {
  children: null
};

export default PlannerCardFrame;
